import MoonlightingMarketingPage from './doctor_moonlighting_jobs_in'

export default (props) => <MoonlightingMarketingPage {...props} keyword="resident"/>


// WEBPACK FOOTER //
// ./src/pages/resident_moonlighting_jobs_in.js